import axios from "axios";

const model = "CACompanies";

export default {
  submitApplication(query, file) {
    let url = `/${model}/submitApplication?`;
    const bodyFormData = new FormData();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    };
    bodyFormData.append("cv", file);
    Object.keys(query).forEach(key => {
      url += `${key}=${query[key]}&`;
    });
    return axios.post(url, bodyFormData, config);
  },

  contactMailing(form) {
    let url = `/${model}/contactMailing`;
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    };

    return axios.post(url, { form }, config);
  },

  propertyMailing(form) {
    let url = `/${model}/propertyMailing`;
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    };

    return axios.post(url, { form }, config);
  },

  verifyPassword(password) {
    return axios.post(`/${model}/verifyPassword`, { password });
  }
};
